import React from 'react';
import { useSelector } from 'react-redux';
import { selectTheme } from '../slices/themeSlice';

const useUpdateDOMTheme = () => {
  const isDark = useSelector(selectTheme);

  React.useEffect(() => {
    const html = window.document.documentElement;
    if (isDark) {
      // DOM manipulation
      if (!html.classList.contains('dark')) {
        html.classList.add('dark');
      }
      // local storage
      // browser setting
    } else {
      // DOM manipulation
      if (html.classList.contains('dark')) {
        html.classList.remove('dark');
      }
      // local storage
      // browser setting
    }
  }, [isDark]);
};

export default useUpdateDOMTheme;
